module.exports = __webpack_public_path__ + "img/userScale2.6cf17db5.png";